<label [attr.for]="formId" class="font-medium text-color-secondary	">
  {{ label }}
  <span class="p-error" *ngIf="required">*</span>
</label>
